import React from 'react'

interface TagIconProps {
  size?: number
  className?: string
}

export const TagIcon: React.FC<TagIconProps> = ({ size = 17, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M0.66 0.66H7.66L15.19 8.19C15.33 8.33 15.44 8.5 15.52 8.68C15.59 8.86 15.63 9.06 15.63 9.26C15.63 9.45 15.59 9.65 15.52 9.83C15.44 10.01 15.33 10.18 15.19 10.32L10.32 15.19C10.18 15.33 10.01 15.44 9.83 15.52C9.65 15.59 9.45 15.63 9.26 15.63C9.06 15.63 8.86 15.59 8.68 15.52C8.5 15.44 8.33 15.33 8.19 15.19L0.66 7.66V0.66Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.16 6.66C5.99 6.66 6.66 5.99 6.66 5.16C6.66 4.34 5.99 3.66 5.16 3.66C4.34 3.66 3.66 4.34 3.66 5.16C3.66 5.99 4.34 6.66 5.16 6.66Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
